import React from 'react';
import NLQueryBox from '../components/NLQueryBox';

export default function NLQueryPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Hỏi đáp NLQ</h2>
        <p className="text-sm text-gray-500 mt-1">Truy vấn dữ liệu bằng ngôn ngữ tự nhiên</p>
      </div>
      <NLQueryBox />
    </div>
  );
}
